import classes from './betKurs.module.css'
import BetKursButtons from '../components/BetKursButtons'

const BetStrategije = () => {
  return (
    <div className={classes.mainContainer}>
      <div className={classes.sidebar}>
        <BetKursButtons type={'betstrategy'} />
      </div>
      <div className={classes.content}>
        <div className={classes.headerContainer}>
          <h1>BET STRATEGIJE</h1>
        </div>

        <p>
          <strong>Znanje + logika + taktika = pametna igra.</strong>
        </p>
        <p>
          Strategije su jedan od najvažnijih segmenata ozbiljnog pristupa igri –
          i to pravilo važi kako za <strong>sportsko klađenje</strong>, tako i
          za <strong>casino igre</strong> i sve druge oblike prediktivne zabave.
          Naša platforma prepoznaje značaj strateškog razmišljanja i upravo zato
          ti predstavljamo sekciju <strong>„STRATEGIJE“</strong>, mesto gde igra
          prestaje da bude slučajnost.
        </p>
        <p>
          Strategije možemo podeliti u <strong>dve osnovne grupe</strong>:
        </p>
        <ul>
          <li>
            <strong>Teorijske strategije</strong> – zasnovane na logici igre,
            ponašanju tržišta i psihologiji izbora.
          </li>
          <li>
            <strong>Matematičke strategije</strong> – utemeljene na sistemima
            verovatnoće, progresiji i numeričkim modelima.
          </li>
        </ul>
        <p>
          Tokom istorije, mnogi poznati{' '}
          <strong>matematičari, analitičari i igrači</strong> razvijali su razne
          pristupe kako bi igru podigli na viši nivo. Neke od tih strategija su
          opstale do danas, jer su pokazale dugoročnu stabilnost i jasno
          definisanu strukturu.
        </p>
        <h3>Šta donosi meni „STRATEGIJE“?</h3>
        <p>U ovoj sekciji ćete pronaći:</p>
        <ul>
          <li>
            konkretne <strong>ideje i taktike za igru</strong>
          </li>
          <li>
            <strong>objašnjenja poznatih i priznatih strategija</strong>
          </li>
          <li>
            detalje o <strong>progresivnim metodama</strong>
          </li>
          <li>
            <strong>BETKO originalne strategije</strong> sa autentičnim nazivima
            i jasnim uputstvima
          </li>
          <li>
            alate za <strong>bolje planiranje i kontrolu igre</strong>
          </li>
          <span>
            i još mnogo toga što će vam pomoći da klađenju pristupite
            analitički, a ne impulsivno.
          </span>
        </ul>
        <p>
          Ova sekcija će se <strong>neprekidno dopunjavati</strong> novim
          strategijama i tehnikama koje možete koristiti u svojoj igri, uz
          jednostavna i razumljiva objašnjenja kako svaka funkcioniše u praksi.
        </p>
        <h3>Važna napomena:</h3>
        <ul>
          <li>
            <strong>Nijedna strategija ne garantuje dobitak.</strong>
          </li>
          <li>
            Strategije služe da vam{' '}
            <strong>pomognu da kontrolišete igru, rizik i emocije</strong> – ali
            klađenje i dalje ostaje igra neizvesnosti.
          </li>
          <li>Igrajte odgovorno.</li>
          <li>Ne dozvolite da hobi preraste u zavisnost.</li>
          <li>Klađenje treba da bude deo zabave, ne problem u životu.</li>
        </ul>
        <h3>Upoznajte svet strategija.</h3>
        <p>
          Otvorite vrata znanju. Uživajte u otkrivanju raznih pristupa igri,
          prilagodite ih sebi i postanite <strong>strateški igrač</strong>, a ne
          puki prognozer. Jer,{' '}
          <strong>kada imaš plan – tvoji potezi imaju smisao</strong>.
        </p>
      </div>
    </div>
  )
}

export default BetStrategije
